<div class="authentication-section">
  <div class="authentication-form-section">
    <img src="assets/login.png" class="authentication-image" />
    <div class="authentication-heading-section">
      <span>Change Password</span>
    </div>
    <div class="authentication-description-section">
      <span>Please enter your password and confirm password to change</span>
    </div>
    <div class="authentication-input-section">
      <img
        src="assets/ic-password-onclick.png"
        class="authentication-input-image"
      />
      <input
        type="{{ password_active ? 'password' : 'text' }}"
        placeholder="New Password"
        class="authentication-input"
        [(ngModel)]="changePasswordFormDetails.values.password"
        (input)="
          passdwordValidation(changePasswordFormDetails.values.password);
          validateInputFields(changePasswordFormDetails, 'password', 'password')
        "
        (keydown.enter)="changePass()"
      />
      <img
        src="assets/show-password.png"
        class="password-icons"
        *ngIf="password_active == false"
        (click)="password_active = true"
      />
      <img
        src="assets/hide-password.png"
        class="password-icons"
        *ngIf="password_active == true"
        (click)="password_active = false"
      />
      <p
        class="authentication-input-error"
        [hidden]="!changePasswordFormDetails.errors.password"
      >
        Password should match the criteria.
      </p>
      <div class="password-strength-section">
        <div class="each-password-strength-section">
          <img
            src="assets/ic-circle-tick.png"
            class="password-strentg-icon"
            *ngIf="
              checkPasswordLength(changePasswordFormDetails.values.password)
            "
          />
          <img
            src="assets/ic-circle-cross.png"
            class="password-strentg-icon"
            *ngIf="
              !checkPasswordLength(changePasswordFormDetails.values.password)
            "
          />
          <span>Minimum 8 Characters</span>
        </div>
        <div class="each-password-strength-section">
          <img
            src="assets/ic-circle-tick.png"
            class="password-strentg-icon"
            *ngIf="
              checkPasswordUppercase(changePasswordFormDetails.values.password)
            "
          />
          <img
            src="assets/ic-circle-cross.png"
            class="password-strentg-icon"
            *ngIf="
              !checkPasswordUppercase(changePasswordFormDetails.values.password)
            "
          />
          <span>Minimum 1 Uppercase Character</span>
        </div>
        <div class="each-password-strength-section">
          <img
            src="assets/ic-circle-tick.png"
            class="password-strentg-icon"
            *ngIf="
              checkPasswordLowercase(changePasswordFormDetails.values.password)
            "
          />
          <img
            src="assets/ic-circle-cross.png"
            class="password-strentg-icon"
            *ngIf="
              !checkPasswordLowercase(changePasswordFormDetails.values.password)
            "
          />
          <span>Minimum 1 Lowercase Character</span>
        </div>
        <div class="each-password-strength-section">
          <img
            src="assets/ic-circle-tick.png"
            class="password-strentg-icon"
            *ngIf="
              checkPasswordSpecial(changePasswordFormDetails.values.password)
            "
          />
          <img
            src="assets/ic-circle-cross.png"
            class="password-strentg-icon"
            *ngIf="
              !checkPasswordSpecial(changePasswordFormDetails.values.password)
            "
          />
          <span>Minimum 1 Special Character</span>
        </div>
        <div class="each-password-strength-section">
          <img
            src="assets/ic-circle-tick.png"
            class="password-strentg-icon"
            *ngIf="
              checkPasswordNumber(changePasswordFormDetails.values.password)
            "
          />
          <img
            src="assets/ic-circle-cross.png"
            class="password-strentg-icon"
            *ngIf="
              !checkPasswordNumber(changePasswordFormDetails.values.password)
            "
          />
          <span>Minimum 1 Numerical Character</span>
        </div>
      </div>
    </div>
    <div class="authentication-input-section">
      <img
        src="assets/ic-password-onclick.png"
        class="authentication-input-image"
      />
      <input
        type="{{ confirm_password_active ? 'password' : 'text' }}"
        placeholder="Confirm Password"
        class="authentication-input"
        [(ngModel)]="changePasswordFormDetails.values.confirm_password"
        (keyup)="
          validateInputFields(
            changePasswordFormDetails,
            'confirm_password',
            'confirm_password'
          )
        "
        (keydown.enter)="changePass()"
      />
      <img
        src="assets/show-password.png"
        class="password-icons"
        *ngIf="confirm_password_active == false"
        (click)="confirm_password_active = true"
      />
      <img
        src="assets/hide-password.png"
        class="password-icons"
        *ngIf="confirm_password_active == true"
        (click)="confirm_password_active = false"
      />
      <p
        class="authentication-input-error"
        [hidden]="!changePasswordFormDetails.errors.confirm_password"
      >
        Password & Confirm Password should be same.
      </p>
    </div>
    <div class="authentication-link-section">
      <span class="authentication-link" (click)="navigate('/login')"
        >Back to Login</span
      >
    </div>
    <div class="authentication-action-section">
      <button
        class="authentication-action"
        (click)="changePass()"
        *ngIf="!button_loading_state"
      >
        RESET
      </button>
      <button class="authentication-action" *ngIf="button_loading_state">
        <div class="loader-1 center"><span></span></div>
      </button>
    </div>
  </div>
  <div class="authentication-video-section">
    <!-- <video class="cmp-video-hero__video" muted="" autoplay="" loop="" playsinline="true" preload="auto">
              <source src="assets/animations/auth-animation.mp4" type="video/webm">
              <source src="assets/animations/auth-animation.mp4" type="video/ogg">
              <source src="assets/animations/auth-animation.mp4" type="video/mp4">
          </video> -->
    <video
      src="assets/animations/auth-animation.mp4"
      type="video/mp4"
      playsinline
      [autoplay]="true"
      [muted]="true"
      [loop]="true"
      [muted]="true"
    ></video>
  </div>
</div>

<ng-template #passwordExistModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>Security Alert</span>
      <span class="page-modal-close-icon" (click)="closePasswordExistModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <p class="page-modal-delete-description">
        You cannot reuse your last 5 passwords. Please create a unique new
        password for enhanced account security.
      </p>
    </div>
    <div class="page-modal-footer-section">
      <button
        class="page-modal-primary-button"
        (click)="closePasswordExistModal()"
      >
        OK
      </button>
    </div>
  </div>
</ng-template>
